// frontend/src/pages/public/PrivacyPage.js
//
// Public privacy policy at uccludhiana.com/privacy. Linked from the Google
// Cloud OAuth consent screen (required to publish the app that connects the
// club's YouTube channel), and useful for members in its own right.

import React from 'react';

const H = ({ children }) => (
  <h2 style={{ fontFamily: 'Rajdhani,sans-serif', fontWeight: 700, fontSize: '1.15rem',
               color: '#1E3A6E', margin: '22px 0 6px' }}>{children}</h2>
);
const P = ({ children }) => (
  <p style={{ fontSize: '0.92rem', lineHeight: 1.6, color: '#374151', margin: '0 0 10px' }}>{children}</p>
);

export default function PrivacyPage() {
  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '24px 18px 60px' }}>
      <div style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: 1, color: '#6b7280' }}>
        UNITED CRICKET CLUB LUDHIANA
      </div>
      <h1 style={{ fontFamily: 'Rajdhani,sans-serif', fontWeight: 800, fontSize: '1.8rem',
                   color: '#1E3A6E', margin: '4px 0 4px' }}>Privacy Policy</h1>
      <div style={{ fontSize: '0.8rem', color: '#9ca3af', marginBottom: 14 }}>Last updated: 2 October 2026</div>

      <P>
        uccludhiana.com is the members' app of United Cricket Club Ludhiana (UCC). It is run by the
        club for its own members, to manage matches, attendance, scores, fees and club communication.
        This page explains what information the app holds and how it is used.
      </P>

      <H>What we hold</H>
      <P>
        For members: name, club member ID, contact details (phone, email), profile photo if added,
        match attendance and availability, scores and statistics, fees, fines and payments, and
        messages and notices sent through the app. Public pages (such as the club page, rankings and
        records) show names, photos and cricket statistics only.
      </P>

      <H>How it is used</H>
      <P>
        Only to run the club: picking teams, recording matches and results, working out fees and
        dues, sending notices and reminders, and publishing the club's cricket records. We do not
        sell or rent information to anyone, and we do not use it for advertising.
      </P>

      <H>YouTube and Google</H>
      <P>
        Club administrators can connect the club's own YouTube channel to the app. This lets the app
        schedule and run live streams of club matches, and link the recorded videos to the matching
        scorecards. The app only acts on the club's channel, only when an administrator uses these
        features, and does not access any member's personal Google or YouTube account.
      </P>
      <P>
        The app's use of information received from Google APIs follows the{' '}
        <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noreferrer">
          Google API Services User Data Policy
        </a>, including its Limited Use requirements. Access can be removed at any time from the
        Google account's security settings. Videos are also subject to{' '}
        <a href="https://www.youtube.com/t/terms" target="_blank" rel="noreferrer">YouTube's Terms of Service</a>{' '}
        and{' '}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google's Privacy Policy</a>.
      </P>

      <H>Who can see what</H>
      <P>
        Members see their own fees, fines and payments. Club administrators can see member records
        to run the club. Everything is stored on secured servers, and access requires signing in.
      </P>

      <H>Your choices</H>
      <P>
        Members can ask the club to correct their details, or to remove them on leaving the club,
        except where records must be kept for the club's accounts.
      </P>

      <H>Contact</H>
      <P>
        Questions about this policy or your information: <a href="mailto:uccludh@gmail.com">uccludh@gmail.com</a>
      </P>
    </div>
  );
}
